import { AxiosResponse } from "axios";
import { APIClient } from "./axiosClient";
import { PaginationResponse, ResponseData } from "./types/_public";
import { IToken } from "./types/_token";
const api = new APIClient();

const path = '/secured/token';
const tokenApi = {
  tokens(params: any): Promise<AxiosResponse<ResponseData<IToken[]> & PaginationResponse, any>> {
    const url = `${path}/getAll`
    return api.get(url, params)
  },
  getQuote(params: any): Promise<AxiosResponse<ResponseData<any>, any>> {
    const url = `${path}/pair/quote`
    return api.get(url, params)
  },
  getQuoteToken(params: any): Promise<AxiosResponse<ResponseData<any>, any>> {
    const url = `${path}/mint/quote`
    return api.get(url, params)
  },
  addToken(data: any): Promise<AxiosResponse<ResponseData<any>, any>> {
    const url = `${path}/addToken`
    return api.post(url, data)
  }
}
export default tokenApi
